import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import Couimg from "../assets/img/oneimg1.png";
import Couimgg from "../assets/img/oneimg2.png";
import Image1 from "../assets/img/courtest1.png";
import Image2 from "../assets/img/courtest4.png";
import Image3 from "../assets/img/courtest3.png";
import Image4 from "../assets/img/courtest2.png";

import Video1 from '../assets/video/video1.mp4';
import Video2 from '../assets/video/video2.mp4';
import Video3 from '../assets/video/video3.mp4';
import Video4 from '../assets/video/video4.mp4';
import Gmailicon from '../assets/img/gmail.png';
import Phoneicon from '../assets/img/phone.png';
import Playbtn from '../assets/img/play.png';

import onebg from '../assets/img/one/twoweekbg.jpg';
import Icon1 from '../assets/img/one/icon1.png';
import Icon2 from '../assets/img/one/icon2.png';
import Icon3 from '../assets/img/one/icon3.png';
import Icon4 from '../assets/img/one/icon4.png';

import Icon5 from '../assets/img/one/icon5.jpg';
import Icon6 from '../assets/img/one/icon6.jpg';
import Icon7 from '../assets/img/one/icon7.jpg';
import Icon8 from '../assets/img/one/icon8.jpg';
import Icon9 from '../assets/img/one/icon9.jpg';
import Right from '../assets/img/one/right.png';
import Right1 from '../assets/img/right11.png';
import Icon51 from '../assets/img/icon51.png';
import Icon61 from '../assets/img/icon61.png';
import Icon71 from '../assets/img/icon71.png';
import Icon81 from '../assets/img/icon81.png';
import Icon91 from '../assets/img/icon91.png';

import imgcha from '../assets/img/one/img4.png';
import imgcha1 from '../assets/img/one/2_week.png';

import SeoHelmet from "../components/SeoHelmet";
import iconstrt from "../assets/img/iconstartt.png";

import CommonModal from "../components/CommonModal";
import RazorpayModal from "../components/RazorpayModal";

const Twoweekdays = () => {
 

const [activeVideo, setActiveVideo] = useState(null);
const [formData, setFormData] = useState({
  name: "",
  email: "",
  phone: ""
});

    
      const handleOpenModal = (videoSrc) => {
        setActiveVideo(videoSrc); // Set the active video source
      };
    
      const handleCloseModal = () => {
        setActiveVideo(null); // Clear the active video source
      };

     


      const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({ ...prevData, [name]: value }));
      };

 

  

  useEffect(() => {
       
    if (window.Swiper) {
      
     

      const swiper = new window.Swiper(".coursesslide", {
        loop: true,
        slidesPerView: 1,
        navigation: {
          nextEl: ".testi-button-next",
          prevEl: ".testi-button-prev",
        },
        breakpoints: {
          768: {
            slidesPerView: 3, 
            spaceBetween: 30,
            navigation: {
              nextEl: ".testi-button-next",
              prevEl: ".testi-button-prev",
            },
          },
          // You can add more breakpoints if needed
        },
      
      });
       
     
    }
  }, []); 


  return (
    <>
 <SeoHelmet />

<CommonModal id="staticBackdrop" />

    <section className="oneofone_section fivedys fivedyss two-weekss" style={{ backgroundImage: `url(${onebg})` }}>
      <div class="container">
        <div className="contentone_outer">
          <div className="title_one">
            <h4>2 Weeks to Your Best Self</h4>
            <h2><span className="two_week_title">2 weeks</span> intense personality and<br></br>
career transformation course
</h2>
          </div>
          <div className="skillbox">
              <ul>
                <li><img src={Icon4}></img><spna>Step Into High-<br></br>Paying Career Roles</spna></li>
                <li><img src={Icon3}></img><spna>Create Your Signature<br></br> Personal Brand</spna></li>
                <li><img src={Icon1}></img><spna>Transform Into a<br></br> Confident Leader</spna></li>
                <li><img src={Icon2}></img><spna>Command Any Room<br></br> with Confidence</spna></li>
              </ul>
          </div>
          <div className="skillbox_content">
              <h3>At the End of the Course You Will Have
 </h3>
              <p>A strong personality, confident communication, and a polished personal style. You’ll also gain the skills and mindset to start your career, build your brand, and step into any space with confidence and ease.</p>
          </div>
          <div className="onedetails">
              <div className="details_col">
                  <h2>Details:</h2>
                   <ul>
                      <li><h4>Duration</h4><spna>2 weeks( Inclusive, full-time)</spna></li>
                      <li><h4>location</h4><spna>2 weeks( Inclusive, full-time)</spna></li>
                      <li><h4>fees</h4><spna> ₹200,000/-</spna></li>
                    </ul>
              </div>
              <div className="details_col-con twoweek">
                <div className="days_box">
                  <h3><p>Week<span>01</span></p>Core Personality & Brand Foundation</h3>
                  <div className="daytext">
                     <p><img className="num" src={Right}></img><img className="num1" src={Right1} ></img>Advanced personality development</p>
                     <p><img className="num" src={Right}></img><img className="num1" src={Right1} ></img> Business & social communication mastery</p>
                     <p><img className="num" src={Right}></img><img className="num1" src={Right1} ></img> Styling for personal brand identity</p>
                     <p><img className="num" src={Right}></img><img className="num1" src={Right1} ></img> Professional self-makeup & camera-ready grooming</p>
                     <p><img className="num" src={Right}></img><img className="num1" src={Right1} ></img> Posture, gestures, body language, and stage presence</p>
                     <p><img className="num" src={Right}></img><img className="num1" src={Right1} ></img> Fashion walk coaching for media and public roles</p>
                     <p><img className="num" src={Right}></img><img className="num1" src={Right1} ></img> Business etiquette, high-level client interactions</p>
                     <p><img className="num" src={Right}></img><img className="num1" src={Right1} ></img> Defining your personal brand essence</p>
                  </div>
                </div>
                <div className="days_box">
                  <h3><p>Week<span>02</span></p>Business, Monetisation  & Career Growth</h3>
                  <div className="daytext">
                     <p><img className="num" src={Right}></img><img className="num1" src={Right1} ></img>Social media positioning and content strategy</p>
                     <p><img className="num" src={Right}></img><img className="num1" src={Right1} ></img> Personal brand photography + visual aesthetics</p>
                     <p><img className="num" src={Right}></img><img className="num1" src={Right1} ></img> Portfolio, resume, and brand material development</p>
                     <p><img className="num" src={Right}></img><img className="num1" src={Right1} ></img> Live projects and real-world client collaborations</p>
                     <p><img className="num" src={Right}></img><img className="num1" src={Right1} ></img>Pitching yourself: brand outreach, negotiation, and partnerships</p>
                     <p><img className="num" src={Right}></img><img className="num1" src={Right1} ></img> Becoming a professional personal shopper or stylist</p>
                     <p><img className="num" src={Right}></img><img className="num1" src={Right1} ></img>Creating a business roadmap: service design, pricing, scaling</p>
                     <p><img className="num" src={Right}></img><img className="num1" src={Right1} ></img> Post-program readiness: launching your own business or becoming a transformation coach</p>
                     <p><img className="num" src={Right}></img><img className="num1" src={Right1} ></img> One-on-one mentorship + customized career feedback</p>
                  </div>
                </div>
               
                
              </div>
          </div>
        </div>
      </div>
    </section>

    <section className="whycho two_whycho">
      <div className="onembr_row">
        <div className="imageoner">
          <img className="oner1" src={imgcha} ></img>
          <img className="oner2" src={imgcha1} ></img>
        </div>
        <div className="contentoner">
          <h2>Why<br></br>Choose This Program ?</h2>
          <ul>
            <li><img className="num" src={Icon5} ></img><img className="num1" src={Icon51} ></img><span>Live Expert Guidance: Receive focused, one-on-one coaching from Bhavana to elevate your personality and presence.</span></li>
            <li><img className="num" src={Icon7} ></img><img className="num1" src={Icon61} ></img><span>Personality-Driven Career Readiness: Gain skills that build confidence, communication, and professional impact to advance your career.</span></li>
            <li><img className="num" src={Icon8} ></img><img className="num1" src={Icon71} ></img><span>Fast-Tracked Personal Transformation: Achieve growth and refinement in your personality that usually takes years to develop.</span></li>
            <li><img className="num" src={Icon6} ></img><img className="num1" src={Icon81} ></img><span>Clarity Without Guesswork: Follow clear frameworks to strengthen self-expression, confidence, and your personal brand effectively.
</span></li>
            <li><img className="num" src={Icon9} ></img><img className="num1" src={Icon91} ></img><span>High-Touch Personality Coaching: Enjoy personalized guidance tailored to your unique strengths, style, and goals.</span></li>
            
          </ul>
          <div className="btngroup">
                <a
                  href="/two-week-transformation"
                  className="terrs_btn" data-bs-toggle="modal" data-bs-target="#staticBackdrop"
                >
                  <img src={iconstrt} alt="" />
                  Get In Touch
                </a>
                <a
  href="#"
  data-bs-toggle="modal"
  data-bs-target="#offlineOnlyModal"
  className="terrs_btn"
>
  <img src={iconstrt} alt="" />
  ENROLL NOW
</a>
              </div>
        </div>
      </div>
    </section>
<RazorpayModal
  id="offlineOnlyModal"
  title="Pay for Only Offline Course"
  courseType="offlineOnly"
/>
    </>
  );
};

export default Twoweekdays;
